import React, { useRef, useState } from "react";
import "./HeroSection.css";
import { useTranslation, Trans } from "react-i18next";

function HeroSection() {
  const { t } = useTranslation();

  const videoRef = useRef(null);
  const heroVisualRef = useRef(null);

  const [isMuted, setIsMuted] = useState(true);
  const [isPlaying, setIsPlaying] = useState(true);

  const toggleSound = () => {
    if (!videoRef.current) return;

    videoRef.current.muted = !videoRef.current.muted;
    setIsMuted(videoRef.current.muted);
  };

  const togglePlay = async () => {
    if (!videoRef.current) return;

    if (videoRef.current.paused) {
      try {
        await videoRef.current.play();
        setIsPlaying(true);
      } catch (error) {
        console.error("Video konnte nicht gestartet werden:", error);
      }
    } else {
      videoRef.current.pause();
      setIsPlaying(false);
    }
  };

  const toggleFullscreen = async () => {
    const container = heroVisualRef.current;
    const video = videoRef.current;

    if (!container || !video) return;

    try {
      if (document.fullscreenElement) {
        await document.exitFullscreen();
        return;
      }

      if (container.requestFullscreen) {
        await container.requestFullscreen();
        return;
      }

      // iPhone / Safari Fallback
      if (video.webkitEnterFullscreen) {
        video.webkitEnterFullscreen();
      }
    } catch (error) {
      console.error("Vollbild konnte nicht geöffnet werden:", error);
    }
  };

  return (
    <section className="hero-container">
      <div className="hero-content">
        <div className="hero-text">
          <h1>
            <Trans
              i18nKey="homepage.title"
              components={[<span className="hero-highlight" />]}
            />
          </h1>

          <p>{t("homepage.section1_text")}</p>

          <div className="hero-btns">
            <a
              href="https://www.apple.com/app-store/"
              target="_blank"
              rel="noopener noreferrer"
              className="store-link"
              aria-label="Apple App Store"
            >
              <img
                src="/images/appStoreLogo.png"
                alt="Apple App Store"
                className="store-badge"
              />
            </a>

            <a
              href="https://play.google.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="store-link"
              aria-label="Google Play Store"
            >
              <img
                src="/images/googlePlayLogo.png"
                alt="Google Play Store"
                className="store-badge"
              />
            </a>
          </div>
        </div>

        <div ref={heroVisualRef} className="hero-visual">
          <video
            ref={videoRef}
            className="hero-video"
            autoPlay
            muted
            loop
            playsInline
            preload="metadata"
            onPlay={() => setIsPlaying(true)}
            onPause={() => setIsPlaying(false)}
          >
            <source src="/videos/onenizer-hero.mp4" type="video/mp4" />
          </video>

          <div className="hero-video-controls">
            <button
              type="button"
              className="hero-video-control-btn"
              onClick={togglePlay}
              aria-label={isPlaying ? "Video pausieren" : "Video abspielen"}
            >
              {isPlaying ? "❚❚" : "▶"}
            </button>

            <button
              type="button"
              className="hero-video-control-btn"
              onClick={toggleSound}
              aria-label={isMuted ? "Ton einschalten" : "Ton ausschalten"}
            >
              {isMuted ? "🔇" : "🔊"}
            </button>

            <button
              type="button"
              className="hero-video-control-btn"
              onClick={toggleFullscreen}
              aria-label="Video im Vollbild anzeigen"
            >
              ⛶
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default HeroSection;
